module.exports = __webpack_public_path__ + "h5/img/suyuan.622ce0bb.png";